export const usePublisherModal = defineStore('publisherModal', {
	state: () => ({
		isOpen: false,
	}),
	actions: {
		openModal() {
			this.isOpen = true
		},
		closeModal() {
			this.isOpen = false
		},
	},
})
